import { type ClipFace } from '~/swr-hooks/clips/faces/types';
import { type FacePerson } from '~/swr-hooks/person/types';

export const hasUnnamedPerson = (person?: Pick<FacePerson, 'firstName' | 'lastName'>) =>
  !person || (!person.firstName && !person.lastName);

// Draft faces are client-only placeholders created before the user finishes
// drawing a region or naming the person. They live in `PeoplePanelContext`
// until the API returns a real face with a server id; consumers use this
// helper to tell them apart instead of hard-coding the `draft-` prefix.
export const isDraftFaceId = (faceId: string): boolean => faceId.startsWith('draft-');

// Some flows (people panel row, FacesBoundingBoxes) only care about faces
// that already carry a real bounding box; drafts that haven't been drawn
// yet are skipped via this guard. Used to live in two call sites.
export const hasFaceRegion = (face: ClipFace | undefined | null): boolean =>
  !!face?.region?.width && !!face?.region?.height;

/** Unnamed draft with no region yet — reclaim on blind draw instead of creating a duplicate row. */
export const findReclaimableUnnamedDraft = (faces: ClipFace[]): ClipFace | undefined =>
  faces.filter((face) => isDraftFaceId(face.id) && !face.person && !hasFaceRegion(face)).at(-1);
